'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('batchDetailController', function (docketService, orderService, jobService, resourceService, userService, xeroService, addressBookService, batchService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, $q, scroll, geolocation, Upload, $location) {
    // Main Variables For Doing Stuff
    $scope.moment = moment;
    $scope.itemEdit = null;
    $scope.selectedIndex = 0;

    // Base Access Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    var timeoutSetting = 500;

    $scope.userCanDoAction = userService.userCanDoAction;

    // Include responsive utilities and UI Functionality
    $scope.splitListFunc = new splitListInterface($scope, $stateParams);

    $scope.$parent.prepareForBatchFromParent = function (batch) {
      $scope.docketBatch = {};
      $scope.docketBatch.localIdentifier = batch.localIdentifier;
      $scope.docketBatch.loading = true;
      $scope.docketBatch.loadingType = "getting";
    }

    $scope.$parent.loadBatchFromParent = function (batch) {
      $scope.docketBatch = batch;

      $scope.loadDocketsForBatch();
      // get batch customer contact
      if ($scope.docketBatch.attribution && $scope.docketBatch.attribution.customer && $scope.docketBatch.attribution.customer.addressBookId) {
        addressBookService.getAddressBookContact($scope.docketBatch.attribution.customer.addressBookId, function (contactItem) {
          $scope.docketBatch.customerContact = contactItem;
          $scope.docketBatch.customerContact.xeroLinked = $scope.docketBatch.customerContact.externalIdentifiers.find(function (extId) {
            if (extId.type == 'xero') {
              return true;
            }
          });
        });
      }
      // get batch supplier contact
      if ($scope.docketBatch.attribution && $scope.docketBatch.attribution.supplier && $scope.docketBatch.attribution.supplier.addressBookId) {
        addressBookService.getAddressBookContact($scope.docketBatch.attribution.supplier.addressBookId, function (contactItem) {
          $scope.docketBatch.supplierContact = contactItem;
          $scope.docketBatch.supplierContact.xeroLinked = $scope.docketBatch.supplierContact.externalIdentifiers.find(function (extId) {
            if (extId.type == 'xero') {
              return true;
            }
          });
        });
      }
      batch.aggregations.forEach(function (aggregate) {
        aggregate.export = false;
        batch.selectedResources.forEach(function (resource) {
          if (resource.resourceId === aggregate.resource.id && resource.interactionName === aggregate.interactionName) {
            aggregate.export = true;
          }
        });
      });
      if ($stateParams.action && $stateParams.action == 'xeroinv') {
        $timeout(function () {
          $scope.generateXeroInvoice();
        }, 1000);
      }
    }

    $scope.$parent.clearBatchFromParent = function () {
      $scope.docketBatch = null;
    }

    $scope.loadDocketsForBatch = function (docketsList) {
      var dockets = $scope.docketBatch.dockets;
      if (dockets && dockets.length > 0) {
        docketService.getDockets({ ids: dockets.join(',') }, function (docketsList) {
          $scope.docketBatch.docketsList = docketsList.sort((a, b) => {
            return $scope.docketBatch.dockets.indexOf(a.id) - $scope.docketBatch.dockets.indexOf(b.id);
          });

          for (var i = 0; i < $scope.docketBatch.docketsList.length; i++) {
            $scope.docketBatch.docketsList[i].status = $scope.docketBatch.docketsList[i].status.charAt(0).toUpperCase() + $scope.docketBatch.docketsList[i].status.slice(1);
          }

        }, function (err) {
          console.error('could not get dockets list', err);
        });
      }
    }

    $scope.saveDocketBatch = function (batch) {
      batch.loading = true;
      batch.loadingType = 'saving';
      // update selectedResources from aggregate.export value
      var selectedResources = { add: [], remove: [] };
      var preSelectedResources = {};
      batch.selectedResources.forEach(function (resource) {
        if (preSelectedResources[resource.resourceId] == null) {
          preSelectedResources[resource.resourceId] = {};
        }
        preSelectedResources[resource.resourceId][resource.interactionName] = true;
      });
      batch.aggregations.forEach(function (aggregate) {
        // check if resource/interaction combo is already in selectedResources
        if (aggregate.export == true && (preSelectedResources[aggregate.resource.id] == null || preSelectedResources[aggregate.resource.id][aggregate.interactionName] == null)) {
          selectedResources.add.push({ resourceId: aggregate.resource.id, interactionName: aggregate.interactionName });
        } else if (aggregate.export != true && preSelectedResources[aggregate.resource.id] != null && preSelectedResources[aggregate.resource.id][aggregate.interactionName] == true) {
          selectedResources.remove.push({ resourceId: aggregate.resource.id, interactionName: aggregate.interactionName });
        }
      });
      var batchUpdate = { id: batch.id, selectedResources: selectedResources };
      batchService.saveBatch(batchUpdate, function (batchUpdated) {
        batch.loading = false;
      }, function (err) {
        console.error('could not update batch aggregation', err);
      });
    }

    /**** Generate Xero Invoice ****/

    $scope.generateXeroInvoice = function () {
      /*$scope.xeroInvoice = {stage:'checkConnection'};
      $("#xeroInvoiceModal").fadeIn(100);*/
      $scope.xeroInvoice = { stage: 'invoiceDetails', type: 'aggregate' };
      $scope.xeroInvoice.stage = 'invoiceDetails';
      $scope.xeroInvoice.type = 'aggregate';
      //$scope.xeroInvoice.target = 'customer';
      // get batch customer contact
      if ($scope.docketBatch.customerContact) {
        $scope.xeroInvoice.customerContact = $scope.docketBatch.customerContact;
      }
      if ($scope.docketBatch.supplierContact) {
        $scope.xeroInvoice.supplierContact = $scope.docketBatch.supplierContact;
        $scope.xeroInvoice.disableSupplier = false;
      } else {
        $scope.xeroInvoice.disableSupplier = true;
      }
      if ($scope.docketBatch.attribution) {
        if ($scope.docketBatch.attribution.supplier && !$scope.docketBatch.attribution.customer && $scope.docketBatch.supplierContact.xeroLinked) {
          $scope.xeroInvoice.target = 'supplier';
        } else if ($scope.docketBatch.customerContact.xeroLinked) {
          $scope.xeroInvoice.target = 'customer';
        }
        $scope.xeroInvoice.disableCustomer = false;
      } else {
        $scope.xeroInvoice.disableCustomer = true;
      }
      /*if ( $scope.currentUser.xeroAuthentication ) {
        var xeroAuthTo = moment($scope.currentUser.xeroAuthentication.authenticatedUntil);
        var duration = moment.duration(xeroAuthTo.diff(moment()));
        if ( duration <= 1 ) {
          $scope.closeXeroInvoiceModal();
          $scope.openXeroConnect();
        } else {
          $scope.xeroInvoice.stage = 'invoiceDetails';
          $scope.xeroInvoice.type = 'aggregate';
          //$scope.xeroInvoice.target = 'customer';
          // get batch customer contact
          if ( $scope.docketBatch.customerContact ) {
            $scope.xeroInvoice.customerContact = $scope.docketBatch.customerContact;
          }
          if ( $scope.docketBatch.supplierContact ) {
            $scope.xeroInvoice.supplierContact = $scope.docketBatch.supplierContact;
            $scope.xeroInvoice.disableSupplier = false;
          } else {
            $scope.xeroInvoice.disableSupplier = true;
          }
          if ( $scope.docketBatch.attribution ) {
            if ( $scope.docketBatch.attribution.supplier && !$scope.docketBatch.attribution.customer && $scope.docketBatch.supplierContact.xeroLinked ) {
              $scope.xeroInvoice.target = 'supplier';
            } else if ( $scope.docketBatch.customerContact.xeroLinked ){
              $scope.xeroInvoice.target = 'customer';
            }
            $scope.xeroInvoice.disableCustomer = false;
          } else {
            $scope.xeroInvoice.disableCustomer = true;
          }
        }
      } else {
        $scope.closeXeroInvoiceModal();
        $scope.openXeroConnect();
      }*/
    }

    $scope.closeXeroInvoiceModal = function () {
      $("#xeroInvoiceModal").fadeOut(100);
    }

    $scope.createInvoice = function () {
      $scope.xeroInvoice.loading = true;
      var postObj = { id: $scope.docketBatch.id, type: $scope.xeroInvoice.type, target: $scope.xeroInvoice.target };
      xeroService.createXeroInvoice(postObj, function (success) {
        $scope.xeroInvoice.loading = false;
        $scope.xeroInvoice.stage = 'success';
      }, function (err) {
        $scope.xeroInvoice.loading = false;
        $scope.xeroInvoice.stage = 'error';
      });
    }

    /**** Xero Connect Modal ****/
    $scope.openXeroConnect = function () {
      $scope.xeroConnectLogin('xeroinv');
    }

    /***** Xero Contact Link *****/
    $scope.linkXeroContact = function (type) {
      $scope.xeroContactSelectFromParent(function (contactSelected) {
        if (contactSelected != null) {
          $scope.docketBatch[type + 'Contact'].xeroLinkLoading = true;
          var xeroId = contactSelected.externalId;
          var contactUpdate = { id: $scope.docketBatch[type + 'Contact'].id, externalIdentifiers: { add: [{ type: 'xero', externalId: xeroId }] } };
          addressBookService.saveContact(contactUpdate, function (contactUpdated) {
            $scope.docketBatch[type + 'Contact'] = contactUpdated;
            $scope.docketBatch[type + 'Contact'].xeroLinked = true;
          }, function (err) {
            $scope.docketBatch[type + 'Contact'].xeroLinkLoading = false;
          });
        }
      });
    }

    /***********************************/
    /***** Alert Parent Controller *****/
    /***********************************/

    $scope.$parent.batchDetailControllerReady();

  });



// WEBPACK FOOTER //
// ./src/controllers/batches/batchDetailController.js